import { defineMessages } from 'react-intl';

export default defineMessages({
    coverLevelLabel: { id: 'cep.endorsement.coverages.breakdown.CoverLevel', defaultMessage: 'Level of cover' },
    whenBreakdownOccurs: {
        id: 'cep.endorsement.coverages.breakdown.WhenBreakdownOccurs',
        defaultMessage: '* When breakdown occurs at least ¼ mile from home'
    },
    ViewOurCoverOptions: {
        id: 'cep.endorsement.coverages.breakdown.ViewOurCoverOptions',
        defaultMessage: 'View cover options.'
    },
    Close: {
        id: 'cep.endorsement.coverages.breakdown.Close',
        defaultMessage: 'Close'
    },
    validationMessages: { id: 'cep.endorsement.coverages.validationMessage', defaultMessage: 'Please select the level of cover you need' }
});
